module.exports = __webpack_public_path__ + "static/shadowdomsearch-a7cc6dff8c4401bd9519073fa59bcd8c.png";